<template>
  <div :id="`${id}_cont`" class="form-group pb-2" v-if="showContent">
    <template v-if="!editMode">
      <div class="d-flex justify-content-between">
        <label v-if="title" :for="id" class="title form-label">{{ title }}</label>
        <template v-if="!disableValidation && (feedback === 'invalid' || feedback === 'valid')">
          <p v-if="feedback === 'invalid'" class="invalid-feedback">
            {{ errorMsg }}
          </p>
          <p v-else-if="feedback === 'valid'" class="valid-feedback">
            {{ validMsg }}
          </p>
        </template>
        <template v-else-if="isRequired">
          <p class="invalid-feedback required">
            Dato obligatorio
          </p>
        </template>
        <template v-else-if="!isRequired && !disableValidation">
          <p class="invalid-feedback optional">
            Dato opcional
          </p>
        </template>
      </div>
    </template>
    <template v-else-if="editMode">
      <div class="d-flex">
        <label v-if="title" :for="id" class="title">{{ title }}</label>
        <template v-if="isRequired && !errorMsgForm && editMode">
          <p class="invalid-feedback required ms-1">*</p>
        </template>
      </div>
    </template>
    <div class="position-relative">
      <v-select :label="labelKey" :filterable="false" :options="filteredItems" v-model="selected" @search="onSearch"
        @open="onOpenSelect"
        :clearable="false" class="form-control v-select" :class="{ disabled: disableSelect }" :editMode="editMode"
        @option:selected="handleChange">
        <template #no-options>Ingrese
          {{
            typeFilter === 'user' ? 'nombre de usuario' :
            (typeFilter === 'vehicle' ? 'patente de vehiculo' :
            (typeFilter === 'vehicle_group' ? 'nombre de grupo' :
            (typeFilter === 'vehicle_alias' ? 'código interno' :
            (typeFilter === 'carrier' ? 'nombre de transportista' :
            (typeFilter === 'client' ? 'nombre de cliente' :
            (typeFilter === 'driver' ? 'nombre de conductor' :
            (typeFilter === 'driver_access_user' ? 'nombre o correo de usuario' :
            (typeFilter === 'driver_access_account_name' ? 'nombre de usuario' :
            (typeFilter === 'driver_access_account_email' ? 'correo de usuario' :
            (typeFilter === 'driver_access_account_phone' ? 'teléfono de usuario' :
            (typeFilter === 'company' ? 'nombre de mandante' :
            (typeFilter === 'zone' ? 'nombre de zona' : 'ID de dispositivo')
            )))))))))))
          }}...</template>
      </v-select>
      <button v-if="selected && !disableSelect" type="button" class="btn btn-clear" @click="clearSelection">
        <i class="ri-close-line"></i>
      </button>
    </div>
  </div>
  <!-- Loading -->
  <div :id="`${id}_cont`" v-else>
    <div class="form-group pb-2">
      <label v-if="title" class="title placeholder-glow col-3">
        <span class="placeholder col-12"></span>
      </label>
      <div class="placeholder-glow">
        <input class="form-control placeholder col-12" />
      </div>
    </div>
  </div>
</template>

<script>
import "vue-select/dist/vue-select.css";
import vSelect from "vue-select";

export default {
  name: "VsudSelectSearch",
  inject: ["api_provider", "urls_server", "securedWebStorage"],
  components: {
    vSelect,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => [],
    },
    errorMsg: {
      type: String,
      default: "Valor incorrecto o nulo",
    },
    validMsg: {
      type: String,
      default: "Completado correctamente",
    },
    typeFilter: {
      type: String,
      default: "",
    },
    // Acota la búsqueda de vehículos a una empresa puntual (intersecta con el scope).
    companyId: {
      type: [Number, String],
      default: null,
    },
    // Precarga un listado inicial acotado al abrir (sin exigir texto de búsqueda).
    preload: {
      type: Boolean,
      default: false,
    },
    // Solo vehículos con el equipamiento MIGPS Protect (módulo driver_access).
    protectOnly: {
      type: Boolean,
      default: false,
    },
    // Vehículos con el equipamiento MIGPS Protect o Wise Sharing (acciones remotas).
    driverProducts: {
      type: Boolean,
      default: false,
    },
    // Acota las opciones a un vehículo puntual (p. ej. conductores con esa patente asignada).
    vehicleId: {
      type: [Number, String],
      default: null,
    },
    userFilter: {
      type: String,
      default: "",
    },
    isRequired: Boolean,
    disableSelect: {
      type: Boolean,
      default: false,
    },
    disableValidation: {
      type: Boolean,
      default: false,
    },
    allFilter: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: String,
      default: " ",
    },
    editMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showContent: false,
      minLoadTime: 1500,
      loadStart: null,
      feedback: "",
      searchQuery: "",
      filteredItems: [],
      selected: null,
      firstTime: true,
      find_value: 0,
    };
  },
  computed: {
    labelKey() {
      if (this.typeFilter === "user") {
          return "full_name_and_email";
      } else if (this.typeFilter === "vehicle") {
          return "plate";
      } else if (this.typeFilter === "vehicle_alias") {
          return "alias";
      } else if (this.typeFilter === "driver_access_account_email") {
          return "email";
      } else if (this.typeFilter === "driver_access_account_phone") {
          return "phone";
      } else if (
          this.typeFilter === "carrier" ||
          this.typeFilter === "client" ||
          this.typeFilter === "driver" ||
          this.typeFilter === "company" ||
          this.typeFilter === "zone" ||
          this.typeFilter === "vehicle_group" ||
          this.typeFilter === "driver_access_user" ||
          this.typeFilter === "driver_access_account_name"
      ) {
          return "name";
      } else if (this.typeFilter === "device") {
          if (this.userFilter) {
            return "full_device_name";
          } else {
            return "id";
          }
      }
      else {
        return "";
      }
    },
  },
  mounted() {
    // console.log('INIT modelValue newVal', this.modelValue, this.title)
    this.loadStart = Date.now();
    window.addEventListener("load", this.onLoad);
    setTimeout(() => {
      this.showContent = true;
    }, this.minLoadTime);

    if (this.modelValue === "") {
      this.feedback = "null";
    }
    // else{
    if(this.$props.modelValue){
      this.onSearchBySelected();
    }
  },
  beforeUnmount() {
    window.removeEventListener("load", this.onLoad);
  },
  watch: {
    modelValue(newVal) {
      // console.log('modelValue newVal', newVal)
      if (newVal === "") {
        if (this.isRequired) {
          this.feedback = "invalid";
        }
        this.selected = null;
        this.searchQuery = "";
      } else {
        if (Array.isArray(this.filteredItems) && this.filteredItems.length > 0) {
          const match = this.filteredItems.find(item => String(item.id) === String(newVal));
          if (match) this.selected = match;
        }
        this.feedback = "valid";

        // Si el valor aún no quedó resuelto, busca explícitamente la opción seleccionada
        if (!this.selected || String(this.selected.id) !== String(newVal)) {
          this.onSearchBySelected();
          this.firstTime = false;
        }
      }
      this.$emit("feedback", this.feedback);
    },
    vehicleId() {
      // Al cambiar el vehículo, se invalidan las opciones/selección cacheadas para
      // que el próximo preload/búsqueda traiga los conductores de la nueva patente.
      this.filteredItems = [];
      this.selected = null;
      this.searchQuery = "";
      this.firstTime = true;
    },
    companyId() {
      // Igual que vehicleId: al cambiar la empresa las opciones cacheadas ya no aplican.
      this.filteredItems = [];
      this.selected = null;
      this.searchQuery = "";
      this.firstTime = true;
      if (this.$props.modelValue) {
        this.$emit("update:modelValue", "");
      }
    },
  },

  methods: {
    // typeFilter "driver_access_account_<name|email|phone>": el sufijo es el campo de búsqueda.
    driverAccessAccountField() {
      const prefix = "driver_access_account_";
      return this.$props.typeFilter.startsWith(prefix)
        ? this.$props.typeFilter.slice(prefix.length)
        : "";
    },
    async get_filters_options(url, type_post="back", sentAllData=false, searchField="") {
      this.find_value++;
      // console.log(" 1    this.find_value: ", this.find_value, " ", this.searchQuery)
      let find_value_current = this.find_value;
      let user_filter = this.$props.userFilter
      let all = this.$props.allFilter
      // let searching = this.searchQuery;
      let postData;
      if(sentAllData == false){
        postData = {
          search: this.searchQuery,
          search_field: searchField,
          user_filter: user_filter,
          id_selected: this.$props.modelValue,
          all: all,
        };
      }else{
        const user_id = this.securedWebStorage.getItem("id")
        const id_company = this.securedWebStorage.getItem("id_company")
        const system_role = this.securedWebStorage.getItem("role")

        postData = {
          search: this.searchQuery,
          user_filter: user_filter,
          id_selected: this.$props.modelValue,
          all: all,
          id_company: id_company,
          user_id: user_id,
          system_role: system_role,
        };
      }

      // Scope opcional por empresa puntual (p. ej. empresa global en driver_access).
      if (this.$props.companyId) {
        postData.scope_company_id = this.$props.companyId;
      }
      // Solicita un listado inicial acotado cuando no hay búsqueda.
      if (this.$props.preload) {
        postData.preload = true;
      }
      // Solo vehículos con el equipamiento MIGPS Protect (mandantes: con el feature vigente).
      if (this.$props.protectOnly) {
        postData.require_protect_equipment = true;
        postData.require_protect_feature = true;
      }
      if (this.$props.driverProducts) {
        postData.require_driver_equipment = true;
      }
      // Acotar a un vehículo puntual (conductores con esa patente asignada vigente).
      if (this.$props.vehicleId) {
        postData.vehicle_id = this.$props.vehicleId;
      }



      try {
        if(type_post == "back"){
          const response = await this.api_provider.post(url, postData);
          if (find_value_current < this.find_value) return;

          if (response && response.data && response.data.options_list) {
            this.filteredItems = response.data.options_list
            const match = this.filteredItems.find(item => String(item.id) === String(this.$props.modelValue));
            if (match) this.selected = match;
          }
        }else{
          const response = await this.api_provider.post_bff_fastapi(url, postData, "post");
          if (find_value_current < this.find_value) return;

          if (response && response.data && response.data.data){
            const resp_data = response.data.data

            if (resp_data && resp_data.options_list && resp_data.options_list != {}) {
              this.filteredItems = resp_data.options_list
              const match = this.filteredItems.find(item => String(item.id) === String(this.$props.modelValue));
              if (match) this.selected = match;
            }
            if (resp_data && resp_data.element_selected && this.firstTime) {
              this.selected = resp_data.element_selected
              this.firstTime = false
              return
            }
          }
        }
      } catch (error) {
        console.log("Error get_filters_options: ", error);
      }
    },
    onLoad() {
      const loadTime = Date.now() - this.loadStart;
      if (loadTime >= this.minLoadTime) {
        this.showContent = true;
      } else {
        setTimeout(() => {
          this.showContent = true;
        }, this.minLoadTime - loadTime);
      }
    },
    onSearchBySelected() {
      // console.log("onSearchBySelected", this.$props.modelValue)
      if (this.$props.modelValue == null) {
        return;
      }

      if (this.$props.typeFilter === "user") {
        this.get_filters_options(this.urls_server.get_users_filter);
      }
      if (this.$props.typeFilter === "vehicle") {
        this.get_filters_options(this.urls_server.get_vehicles_filter);
      }
      if (this.$props.typeFilter === "carrier") {
        this.get_filters_options(this.urls_server.get_carriers_filter);
      }
      if (this.$props.typeFilter === "client") {
        this.get_filters_options(this.urls_server.get_clients_filter);
      }
      if (this.$props.typeFilter === "driver") {
        this.get_filters_options(this.urls_server.get_drivers_filter);
      }
      if (this.$props.typeFilter === "company") {
        this.get_filters_options(this.urls_server.get_companies_filter);
      }
      if (this.$props.typeFilter === "device") {
        this.get_filters_options(this.urls_server.get_gps_devices);
      }
      if (this.$props.typeFilter === "zone") {
        const url = `/zones/filter_text`;
        this.get_filters_options(url, "mux", true);
      }
      if (this.$props.typeFilter === "vehicle_group") {
        this.get_filters_options(this.urls_server.get_vehicle_groups_filter);
      }
      if (this.$props.typeFilter === "driver_access_user") {
        this.get_filters_options(this.urls_server.get_driver_access_users);
      }
      if (this.driverAccessAccountField()) {
        this.get_filters_options(
          this.urls_server.get_driver_access_accounts, "back", false, this.driverAccessAccountField()
        );
      }
    },
    onOpenSelect() {
      // Para grupos de vehículos precargamos hasta 10 opciones accesibles al abrir
      if (this.$props.typeFilter === "vehicle_group" && this.filteredItems.length === 0) {
        this.searchQuery = "";
        this.get_filters_options(this.urls_server.get_vehicle_groups_filter);
        return;
      }
      // Preload genérico: reutiliza el mapeo typeFilter->endpoint con búsqueda vacía.
      if (this.$props.preload && this.filteredItems.length === 0) {
        this.searchQuery = "";
        this.onSearchBySelected();
      }
    },
    onSearch(text_search) {
      this.searchQuery = text_search;
      // vehicle_group: busca con cualquier longitud (incluye vacío -> hasta 10)
      if (this.$props.typeFilter === "vehicle_group") {
        this.get_filters_options(this.urls_server.get_vehicle_groups_filter);
        return;
      }
      if (this.searchQuery.trim().length >= 3) {
        if (this.$props.typeFilter === "user") {
          this.get_filters_options(this.urls_server.get_users_filter);
        }
        if (this.$props.typeFilter === "vehicle") {
          this.get_filters_options(this.urls_server.get_vehicles_filter, "back", false, "plate");
        }
        if (this.$props.typeFilter === "vehicle_alias") {
          this.get_filters_options(this.urls_server.get_vehicles_filter, "back", false, "alias");
        }        
        if (this.$props.typeFilter === "carrier") {
        this.get_filters_options(this.urls_server.get_carriers_filter);
        }
        if (this.$props.typeFilter === "client") {
          this.get_filters_options(this.urls_server.get_clients_filter);
        }
        if (this.$props.typeFilter === "driver") {
          this.get_filters_options(this.urls_server.get_drivers_filter);
        }
        if (this.$props.typeFilter === "driver_access_user") {
          this.get_filters_options(this.urls_server.get_driver_access_users);
        }
        if (this.driverAccessAccountField()) {
          this.get_filters_options(
            this.urls_server.get_driver_access_accounts, "back", false, this.driverAccessAccountField()
          );
        }
        if (this.$props.typeFilter === "company") {
        this.get_filters_options(this.urls_server.get_companies_filter);
        }
        if (this.$props.typeFilter === "device") {
          if (this.searchQuery.trim().length >= 5) {
            this.get_filters_options(this.urls_server.get_gps_devices);
          }
        }
        if (this.$props.typeFilter === "zone") {
          const url = `/zones/filter_text`;
          this.get_filters_options(url, "mux", true);
        }
        if (this.$props.typeFilter === "vehicle_group") {
          this.get_filters_options(this.urls_server.get_vehicle_groups_filter);
        }
      } else {
        this.filteredItems = [];
      }
    },
    handleChange(option) {
      const value = option?.id ?? this.selected?.id;
      if (value != null) {
        this.$emit('update:modelValue', value);
      }
    },
    clearSelection() {
      this.selected = null;
      this.searchQuery = "";
      this.$emit("update:modelValue", "");
      this.$emit("input", "");
    }
  },
};
</script>

<style scoped>
.optional {
  color: var(--gray-text);
}

.gray-border {
  border: var(--light-gray) solid 1px !important;
}

.valid-border {
  border: #66d432 solid 1px !important;
}

.invalid-border {
  border: #fd5c70 solid 1px !important;
}

.title {
  color: var(--black);
  font-size: 0.9rem;
  font-weight: 500;
}

select {
  border: 1px solid var(--light-gray);
  border-radius: 0.7rem;
}

select:focus {
  border: 1px solid var(--blue);
  outline: 0;
  box-shadow: none;
}

.was-validated .form-select:valid:focus,
.form-select.is-valid:focus,
.was-validated .form-select:invalid:focus,
.form-select.is-invalid:focus {
  box-shadow: none;
}

.dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
}

.dropdown-menu {
  max-height: 200px;
  overflow-y: auto;
  padding: 0.5rem 0;
  border: 1px solid #ced4da;
  border-radius: 0.7rem;
  background-color: white;
}

.dropdown-menu li {
  cursor: pointer;
  padding: 0.5rem 1rem;
}

.dropdown-menu li:hover {
  background-color: #f2f2f2;
}

.v-select.form-control {
  border-radius: 0.75rem;
  padding: 0 6px 0 12px;
}

.disabled {
  pointer-events: none;
  color: #bfcbd9;
  cursor: not-allowed;
  background-image: none;
  background-color: #eef1f6;
  border-color: #d1dbe5;
}
</style>
<style>
.vs__dropdown-toggle {
  padding: 0.3rem 0;
  border: none;
}

.vs__selected {
  padding: 0;
  margin: 0;
}

.vs__actions .vs__open-indicator,
.vs__actions .vs__clear {
  background-repeat: no-repeat;
  background-position: center;
  background-size: 0.75rem;
}

.vs__actions .vs__open-indicator {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e");
}

.vs__actions .vs__clear {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M3 3L13 13M13 3L3 13'/%3e%3c/svg%3e");
}

.vs__actions .vs__open-indicator path,
.vs__actions .vs__clear path {
  opacity: 0;
}

.vs__actions {
  padding-top: 0;
}

.vs__dropdown-menu {
  top: 44px;
  border-radius: 0.75rem;
  border: none;
  box-shadow: 0 8px 26px -4px rgba(20, 20, 20, 0.15), 0 8px 9px -5px rgba(20, 20, 20, 0.06);
  padding-top: 10px;
  padding-bottom: 10px;
}

.position-relative {
  position: relative;
}

.btn-clear {
  position: absolute;
  top: 1px;
  right: 1.5rem;
  background: transparent;
  border: none;
  cursor: pointer;
  z-index: 1;
  box-shadow: none !important;
  margin-bottom: 0!important;
  padding: 8px 12px !important;
}

button.btn.btn-clear:not(:disabled):not(.disabled):active{
  background-color: white;
}

.btn-clear i {
  font-size: 16px;
  color: rgb(73, 80, 87);
}
</style>